

const PAD = 16;
const FIT_UPSCALE = 2;
const MAX_UPSCALE = 3;
const STEP = 1.4;
const CLICK_ZOOM = 2.2;
const PAN = 80;
const CLICK_SLOP = 6;
const OPEN_GUARD = 400;

const dlg = document.getElementById('zoom-dialog');
if (dlg) init();

function init() {
  const $ = id => dlg.querySelector('#' + id);
  const stage = $('zoom-stage'), img = $('zoom-img'), level = $('zoom-level'), title = $('zoom-title'), note = $('zoom-note');
  const btnIn = $('zoom-in'), btnOut = $('zoom-out'), btnFit = $('zoom-reset');
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  let z = 1, tx = 0, ty = 0;
  let bw = 0, bh = 0, zmax = 2;
  const pointers = new Map();
  let gesture = null;
  let closeOnClick = false;
  let openedAt = 0;

  function layout() {
    const W = stage.clientWidth, H = stage.clientHeight, nw = img.naturalWidth, nh = img.naturalHeight;
    if (!W || !H || !nw || !nh) return;
    const f = Math.min((W - 2 * PAD) / nw, (H - 2 * PAD) / nh, FIT_UPSCALE);
    bw = nw * f; bh = nh * f; img.style.width = bw + 'px'; img.style.height = bh + 'px';
    zmax = clamp(MAX_UPSCALE / f, 2, 8);
    apply(z, tx, ty);
  }

  function apply(nz, nx, ny, smooth = false) {
    z = clamp(nz, 1, zmax);
    const mx = Math.max(0, (bw * z - (stage.clientWidth - 2 * PAD)) / 2), my = Math.max(0, (bh * z - (stage.clientHeight - 2 * PAD)) / 2);
    tx = clamp(nx, -mx, mx); ty = clamp(ny, -my, my);
    img.classList.toggle('is-smooth', smooth);
    img.style.transform = `translate(calc(-50% + ${tx.toFixed(1)}px), calc(-50% + ${ty.toFixed(1)}px)) scale(${z.toFixed(4)})`;
    const fitted = z < 1.001;
    level.textContent = Math.round(z * 100) + '%';
    btnOut.disabled = fitted; btnFit.disabled = fitted; btnIn.disabled = z > zmax - 0.001;
    stage.classList.toggle('is-zoomed', !fitted);
  }

  function zoomAt(nz, px, py, smooth) {
    nz = clamp(nz, 1, zmax); const k = nz / z;
    apply(nz, px - (px - tx) * k, py - (py - ty) * k, smooth);
  }
  const at = e => { const r = stage.getBoundingClientRect(); return [e.clientX - r.left - r.width / 2, e.clientY - r.top - r.height / 2]; };
  const two = () => { const [a, b] = [...pointers.values()]; return { d: Math.hypot(b[0] - a[0], b[1] - a[1]) || 1, m: [(a[0] + b[0]) / 2, (a[1] + b[1]) / 2] }; };

  function open(btn) {
    const src = document.querySelector(btn.dataset.enlarge), url = src && (src.currentSrc || src.src);
    if (!url || dlg.open) return;
    const text = sel => (sel && document.querySelector(sel)?.textContent.trim()) || '';
    title.textContent = text(btn.dataset.enlargeTitle); note.textContent = text(btn.dataset.enlargeNote);
    dlg.setAttribute('aria-label', 'Enlarged picture' + (title.textContent ? ': ' + title.textContent : ''));
    z = 1; tx = ty = 0; pointers.clear(); gesture = null; closeOnClick = false;
    img.style.visibility = 'hidden'; img.alt = src.alt || '';
    if (img.getAttribute('src') !== url) img.src = url;
    dlg.showModal(); openedAt = performance.now();
    const ready = () => { layout(); img.style.visibility = ''; };
    if (img.complete && img.naturalWidth) ready(); else img.addEventListener('load', ready, { once: true });
  }
  document.addEventListener('click', e => { const b = e.target.closest && e.target.closest('[data-enlarge]'); if (b) open(b); });
  $('zoom-close').addEventListener('click', () => dlg.close());
  dlg.addEventListener('close', () => { pointers.clear(); gesture = null; closeOnClick = false; });
  img.addEventListener('error', () => { if (dlg.open) dlg.close(); });
  new ResizeObserver(() => { if (dlg.open) layout(); }).observe(stage);

  btnIn.addEventListener('click', () => zoomAt(z * STEP, 0, 0, true));
  btnOut.addEventListener('click', () => zoomAt(z / STEP, 0, 0, true));
  btnFit.addEventListener('click', () => apply(1, 0, 0, true));
  dlg.addEventListener('keydown', e => {
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    const move = { ArrowLeft: [PAN, 0], ArrowRight: [-PAN, 0], ArrowUp: [0, PAN], ArrowDown: [0, -PAN] }[e.key];
    if (e.key === '+' || e.key === '=') zoomAt(z * STEP, 0, 0, true);
    else if (e.key === '-' || e.key === '_') zoomAt(z / STEP, 0, 0, true);
    else if (e.key === '0') apply(1, 0, 0, true);
    else if (move) apply(z, tx + move[0], ty + move[1], true);
    else return;
    e.preventDefault();
  });

  stage.addEventListener('wheel', e => {
    e.preventDefault();
    const unit = e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? stage.clientHeight : 1;
    zoomAt(z * Math.exp(-e.deltaY * unit * (e.ctrlKey ? 0.01 : 0.0015)), ...at(e));
  }, { passive: false });

  function begin(onPicture, time, wasPinch) {
    if (pointers.size === 1) gesture = { kind: 'drag', p0: [...pointers.values()][0], t0: [tx, ty], moved: wasPinch ? Infinity : 0, onPicture, time };
    else if (pointers.size === 2) { const { d, m } = two(); gesture = { kind: 'pinch', d0: d, m0: m, z0: z, t0: [tx, ty] }; }
  }
  stage.addEventListener('pointerdown', e => {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    try { stage.setPointerCapture(e.pointerId); } catch (err) {   }
    pointers.set(e.pointerId, at(e)); closeOnClick = false;
    begin(e.target === img, e.timeStamp, false);
  });
  stage.addEventListener('pointermove', e => {
    if (!pointers.has(e.pointerId) || !gesture) return;
    pointers.set(e.pointerId, at(e));
    if (gesture.kind === 'drag' && pointers.size === 1) {
      const p = pointers.get(e.pointerId), dx = p[0] - gesture.p0[0], dy = p[1] - gesture.p0[1];
      gesture.moved = Math.max(gesture.moved, Math.hypot(dx, dy));
      if (z > 1.001 && gesture.moved >= CLICK_SLOP) apply(z, gesture.t0[0] + dx, gesture.t0[1] + dy);
    } else if (gesture.kind === 'pinch' && pointers.size === 2) {
      const { d, m } = two(), nz = clamp(gesture.z0 * d / gesture.d0, 1, zmax), k = nz / gesture.z0;
      apply(nz, m[0] - (gesture.m0[0] - gesture.t0[0]) * k, m[1] - (gesture.m0[1] - gesture.t0[1]) * k);
    }
  });
  const end = e => {
    if (!pointers.has(e.pointerId)) return;
    const g = gesture, p = pointers.get(e.pointerId);
    pointers.delete(e.pointerId); gesture = null;
    if (pointers.size) { begin(false, e.timeStamp, true); return; }
    if (e.type !== 'pointerup' || !g || g.kind !== 'drag' || g.moved >= CLICK_SLOP || performance.now() - openedAt < OPEN_GUARD) return;
    if (!g.onPicture) closeOnClick = true;
    else if (z < 1.001) zoomAt(Math.min(zmax, CLICK_ZOOM), p[0], p[1], true);
    else apply(1, 0, 0, true);
  };
  stage.addEventListener('pointerup', end);

  stage.addEventListener('click', () => { if (closeOnClick) { closeOnClick = false; dlg.close(); } });
  stage.addEventListener('pointercancel', end);
}
